import React, { useRef, useEffect, useCallback, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Tabs, TabList, TabPanels, Tab, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, useDisclosure, Text, Button, Flex, Badge, Stack } from '@chakra-ui/react';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import * as Yup from 'yup';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { useToast } from '../../../hooks/toast';
import { AppError } from '../../../utils/AppError';
import { formatPrice } from '../../../utils/format';
import getValidationErrors from '../../../utils/getValidationErrors';
import formatPriceNumber from '../../../utils/formatPriceNumber';
import Loading from '../../Loading';
import Input from '../../Inputs/Input';
import InputSelect from '../../Inputs/Selects/InputSelect';
// import SelectInput from '../../Inputs/Selects/SelectInputAntigo';
import SelectInput from '../../Inputs/Selects/SelectInput';

import {
  Container,
  Content,
  Header,
  TabsView,
	TabConta,
	TabBoleto,
	TabPix,
  FormView,
  Buttons,
  SelectedYesNo,
	TabUsers
} from './styles';

type ContaDATA = {
	id_emp: string;
	id_caixa: number;
	url_banco: string;
	conta_tipo: string;
	conta_desc: string;
	banco_cod: string;
	banco_agencia: string;
	banco_agencia_dig: string;
	banco_conta_nro: string;
	banco_conta_dig: string;
	limite_credito: number;
	cartao_conta_deb_nro: string;
	cartao_conta_deb_dig: string;
	cartao_nro: string;
	cartao_nome: string;
	cartao_mes_validade: string;
	cartao_ano_validade: string;
	cartao_dia_vencimento: number;
	cartao_melhor_dia_compra: number;
	boleto: {
		documento: string;
		nome_boleto: string;
		cedente: string;
		carteira: string;
		variacao: string;
		codtrans240: string;
		codtrans400: string;
		tip_dist: number;
		tip_arq: number;
		tip_carteira: number;
		especie: string;
		rep_emissao: string;
		aceite: string;
	};
	pix: {
		client_id: string;
		client_secret: string;
		key_user: string;
		chave_pix: string;
		ssl_lib: string;
	};
	users: string[];
}
interface ModalParams {
	onClose: any;
	isVisible: boolean;
	conta: ContaDATA;
	fetchContas: () => Promise<void>;
	usuarios: any[];
}

const months = [
	{ id: '01', label: '01 - JANEIRO' },
	{ id: '02', label: '02 - FEVEREIRO' },
	{ id: '03', label: '03 - MARÇO' },
	{ id: '04', label: '04 - ABRIL' },
	{ id: '05', label: '05 - MAIO' },
	{ id: '06', label: '06 - JUNHO' },
	{ id: '07', label: '07 - JULHO' },
	{ id: '08', label: '08 - AGOSTO' },
	{ id: '09', label: '09 - SETEMBRO' },
	{ id: '10', label: '10 - OUTUBRO' },
	{ id: '11', label: '11 - NOVEMBRO' },
	{ id: '12', label: '12 - DEZEMBRO' },
];
const years = Array.from({ length: 30 }, (_, i) => ({ id: `${new Date().getFullYear() + i}`, label: `${new Date().getFullYear() + i}`}));
const days = Array.from({ length: 31 }, (_, i) => ({ id: `${i + 1}`, label: `${i + 1}` }));

const selectTipoConta = [
	{ id: 'B', label: 'BANCO' },
	{ id: 'C', label: 'CAIXA' },
	{ id: 'CR', label: 'CARTÃO' }
];
const selectTipoArquivo = [
	{ id: '1', label: 'CNAB 240' },
	{ id: '2', label: 'CNAB 400' }
];
const selectTipoDistribuicao = [
	{ id: '1', label: 'CLIENTE' },
	{ id: '2', label: 'BANCO' }
];
const selectTipoCarteira =[
	{ id: '1', label: 'SIMPLES' },
	{ id: '2', label: 'VINCULADA' },
	{ id: '3', label: 'CAUCIONADA' },
	{ id: '4', label: 'DESCONTADA' },
	{ id: '5', label: 'VENDOR' },
	{ id: '6', label: 'DIRETA' },
];
const selectTipoEspecie = [
	{ id: 'DM', label: 'DM' },
	{ id: 'DR', label: 'DR' },
	{ id: 'NP', label: 'NP' },
	{ id: 'NF', label: 'NF' },
];

const ModalConta: React.FC<ModalParams> = ({
  onClose = () => {},
  isVisible,
  conta,
	fetchContas,
	usuarios
}) => {
  const formRef = useRef<FormHandles>(null);
  const formRefBoleto = useRef<FormHandles>(null);
	const formRefPix = useRef<FormHandles>(null);

  const { company, token } = useAuth();
  const { addToast} = useToast();

  const [visible, setVisible] = useState(isVisible);
	const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

	const [tipoConta, setTipoConta] = useState(conta.conta_tipo ? conta.conta_tipo : '');
	const [banks, setBanks] = useState([]);
	const [radioAceite, setRadioAceite] = useState(conta.boleto?.aceite ? conta.boleto.aceite : 'N');

	const [createConta, setCreateConta] = useState(Object.keys(conta).length > 0 ? conta : {} as any);

	const { isOpen, onOpen, onClose: onCloseAlert } = useDisclosure();
	const cancelRef = useRef(null);

	async function fetchBanks() {
		try {
			// delete api.defaults.headers.authorization;
			// delete api.defaults.headers.company;
      delete api.defaults.headers.common['Authorization'];
      delete api.defaults.headers.common['company'];

			const { data } = await api.get('https://brasilapi.com.br/api/banks/v1');

			data.map((item: any) => {
				item.value = item.code ? String(item.code) : '--';
				item.label = `${item.code ? item.code : '--'} - ${item.name}`;
			});

			const filtered = data.filter((item: any) => item.code !== null);
			setBanks(filtered);

			// PARA PREENCHER O CAMPO banco_cod
			if (conta.banco_cod) {
				const index = filtered.findIndex((item: any) => item.value === String(conta.banco_cod));
				formRef.current?.setFieldValue('banco_cod', filtered[index]);
			}
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar a conta.';

			addToast({
				type: 'error',
				title: 'Buscar Bancos!',
				description: msg,
			});
		}
		finally {
			// api.defaults.headers.authorization = `Bearer ${token}`;
			// api.defaults.headers.company = company.id;
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.defaults.headers.common['company'] = company.id;

			setLoading(false);
		}
	};

  useEffect(() => {
		if (createConta.limite_credito)	{
			const auxLimite = formatPrice(createConta.limite_credito);
			
			setCreateConta({ ...createConta, limite_credito: auxLimite});
			formRef.current?.setFieldValue('limite_credito', auxLimite);
		}

		const fetch = async () => fetchBanks();

		fetch();
  }, [conta]);

	const handleMoeda = useCallback(() => {
		let moedastr = formRef.current?.getFieldValue('limite_credito');
		moedastr = moedastr.replace(/\D/g, '');

		if (moedastr) {
			const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

			let tmp = `${moeda}`;
			tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
			if (tmp.length > 6)
				tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

			formRef.current?.setFieldValue('limite_credito', `R$ ${tmp}`);
		} else {
			moedastr = moedastr.replace(/\D/g, '');
			formRef.current?.setFieldValue('limite_credito', `${moedastr}`);
		}
	}, []);

	async function handleSubmitConta(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				conta_tipo: Yup.string().required('Tipo de conta é obrigatório'),
				conta_desc: Yup.string().required('Descrição da conta é obrigatório'),
				banco_cod: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'B' || conta_tipo === 'CR')
						return schema.required('Código do banco é obrigatório.')
					return schema;
					// is: '1' || '3',
					// then: Yup.string().required('Código do banco obrigatório.')
				}),
				banco_agencia: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'B')
						return schema.required('Agência do banco é obrigatório.')
					return schema;
				}),
				banco_agencia_dig: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'B')
						return schema.required('Dígito da agência é obrigatório.')
					return schema;
				}),
				banco_conta_nro: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'B')
						return schema.required('Número da conta é obrigatório.')
					return schema;
				}),
				banco_conta_dig: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'B')
						return schema.required('Dígito da conta é obrigatório.')
					return schema;
				}),
				cartao_conta_deb_nro: Yup.string(),
				cartao_conta_deb_dig: Yup.number(),
				cartao_nro: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Número do cartão é obrigatório.')
					return schema;
				}),
				limite_credito: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Limite de crédito é obrigatório.')
					return schema;
				}),
				cartao_nome: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Nome do cartão é obrigatório.')
					return schema;
				}),
				cartao_mes_validade: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Mês de validade do cartão é obrigatório.')
					return schema;
				}),
				cartao_ano_validade: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Ano de validade do cartão é obrigatório.')
					return schema;
				}),
				cartao_dia_vencimento: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Dia de vencimento do cartão é obrigatório.')
					return schema;
				}),
				cartao_melhor_dia_compra: Yup.string().when('conta_tipo', (conta_tipo, schema) => {
					if (conta_tipo === 'CR')
						return schema.required('Melhor dia de compra do cartão é obrigatório.')
					return schema;
				}),
			});

			await schema.validate(form, { abortEarly: false });

			const {
				conta_tipo,
				conta_desc,
				conta_cod,
				banco_agencia,
				banco_agencia_dig,
				banco_conta_nro,
				banco_conta_dig,
				cartao_conta_deb_nro,
				cartao_conta_deb_dig,
				cartao_nro,
				limite_credito,
				cartao_nome,
				cartao_mes_validade,
				cartao_ano_validade,
				cartao_dia_vencimento,
				cartao_melhor_dia_compra
			} = form;

			const auxConta = {
				...createConta,
				conta_tipo,
				conta_desc,
				conta_cod,
				banco_agencia,
				banco_agencia_dig,
				banco_conta_nro,
				banco_conta_dig,
				cartao_conta_deb_nro,
				cartao_conta_deb_dig,
				cartao_nro,
				limite_credito,
				cartao_nome,
				cartao_mes_validade,
				cartao_ano_validade,
				cartao_dia_vencimento,
				cartao_melhor_dia_compra
			};

			setCreateConta({ ...auxConta });

			setTabIndex(1);
		}
		catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
			}
		}
  };

	async function handleSubmitBoleto(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				documento: Yup.string(),
				nome_boleto: Yup.string(),
				cedente: Yup.string(),
				carteira: Yup.string(),
				variacao: Yup.string(),
				codtrans240: Yup.string(),
				codtrans400: Yup.string(),
				tip_dist: Yup.string(),
				tip_arq: Yup.string(),
				tip_carteira: Yup.string(),
				especie: Yup.string(),
				rep_emissao: Yup.string()
			});

			await schema.validate(form, { abortEarly: false });

			const {
				documento,
				nome_boleto,
				cedente,
				carteira,
				variacao,
				codtrans240,
				codtrans400,
				tip_dist,
				tip_arq,
				tip_carteira,
				especie,
				rep_emissao
			} = form;

			const auxBoleto = {
				documento,
				nome_boleto,
				cedente,
				carteira,
				variacao,
				codtrans240,
				codtrans400,
				tip_dist: Number(tip_dist),
				tip_arq: Number(tip_arq),
				tip_carteira: Number(tip_carteira),
				especie,
				rep_emissao,
				aceite: radioAceite
			};

			setCreateConta({ ...createConta, boleto: { ...auxBoleto } });

			setTabIndex(2);

		} catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
			}
		}
	};

	async function handleSubmitPix(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				client_id: Yup.string(),
				client_secret: Yup.string(),
				key_user: Yup.string(),
				chave_pix: Yup.string(),
				ssl_lib: Yup.string()
			});

			await schema.validate(form, { abortEarly: false });

			const {
				client_id,
				client_secret,
				key_user,
				chave_pix,
				ssl_lib
			} = form;

			const auxPix = {
				client_id,
				client_secret,
				key_user,
				chave_pix,
				ssl_lib
			};

			// const auxConta = { ...createConta, ...auxPix };
			setCreateConta({ ...createConta, pix: { ...auxPix } });

			// await handleSubmitCadastro(auxConta);
			setTabIndex(3);
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current?.setErrors(errors);
			}
		}
	};

	async function handleCancelar() {
		formRef.current?.reset();
		setVisible(false);
		onClose();
	};

	async function handleAddUser(user: any) {
		try {
			const auxUsers = createConta.users ? createConta.users : [] as string[];

			const index = auxUsers.findIndex((elem: string) => elem === user.id_cliente);

			if (index > -1) {
				auxUsers.splice(index, 1);
				setCreateConta({ ...createConta, users: auxUsers });
				return;
			}

			auxUsers.push(user.id_cliente);

			setCreateConta({ ...createConta, users: auxUsers });

		} catch (error) {
			console.log('ERROr user ==> ', error);
		}
	};

  async function handleSubmitCadastro(dataa: any) {
		try {
			setLoading(true);

			dataa.limite_credito = dataa.limite_credito
				? formatPriceNumber(dataa.limite_credito)
				: '';

			const auxConta = {
				...dataa,
				id_emp: company.id,
				id_caixa: conta.id_caixa ? conta.id_caixa : '0',
				banco_cod: tipoConta === 'C' ? '0' : formRef.current?.getFieldValue('banco_cod')
			};

			const contaFilter = Object.fromEntries(Object.entries(auxConta).filter(([_, V]) =>
				V !== '' && V !== undefined
			));


			const { data } = await api.post('portal/conta/store', { conta: contaFilter });

			if (data.che === 'N') {
				addToast({
					type: 'error',
					title: 'Conta',
					description: data.msg,
				});

			} else {
				addToast({
					type: 'success',
					title: 'Conta',
					description: data.msg,
				});
			}
		}
		catch (error) {
			console.log('ERROR ==> ', error);

			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível criar/editar a conta.';

			addToast({
				type: 'error',
				title: 'Criar/Editar Conta!',
				description: msg,
			});
		}
		finally {
			setCreateConta({});
			setLoading(false);
			onClose();
			fetchContas();
		}
  };

  return (
		<>
			{loading && <Loading />}

			<Container id="ModalConta">
				<Content className={`${visible ? 'active' : ''}`}>
					<Header>
						<h1>{conta?.conta_desc ? conta.conta_desc : 'Novo Item'}</h1>
					</Header>

					<TabsView>
						<Tabs className="tabs" index={tabIndex}>
							<TabList className="tab-list">
								<Tab className="tab" onClick={() => setTabIndex(0)}>
									Conta
								</Tab>

								{tipoConta === 'B' && (
									<>
										<Tab className="tab" onClick={() => setTabIndex(1)}>
											Boleto
										</Tab>

										<Tab className="tab" onClick={() => setTabIndex(2)}>
											Pix
										</Tab>
									</>
								)}

								<Tab className="tab" onClick={() => setTabIndex(tipoConta === 'B' ? 3 : 1)}>
									Usuários
								</Tab>
							</TabList>

							<TabPanels className="tab-panels">
								<TabConta className="tab-panel">
									<FormView ref={formRef} onSubmit={handleSubmitConta} initialData={conta}>
										<div className="form-left">
											{/* TIPO DA CONTA */}
											<div className="input">
												<p>Tipo conta <span>obrigatório</span></p>

												<InputSelect
													name="conta_tipo"
													placeholder="Tipo conta"
													options={selectTipoConta}
													defaultValue={conta.conta_tipo ? conta.conta_tipo : ''}
													containerStyle={{ padding: '6px 10px' }}
													onChange={(e: any) => {
														const auxValue = e.target.value;
														formRef.current?.reset();
														formRefBoleto.current?.reset();
														formRefPix.current?.reset();
														setTipoConta(auxValue);
														formRef.current?.setFieldValue('conta_tipo', auxValue);
													}}
												/>
											</div>

											{/* DESCRIÇÃO CONTA */}
											<div className="input">
												<p>Descrição conta <span>obrigatório</span></p>

												<Input
													name="conta_desc"
													type="text"
													placeholder="Descrição conta"
													containerStyle={{ padding: '5px 10px' }}
												/>
											</div>

											{tipoConta !== 'C' && (
												<>
													{/* CÓDIGO DO BANCO */}
													<div className="input">
														<p>Código do banco <span>obrigatório</span></p>

														<SelectInput
															name="banco_cod"
															placeholder="Código banco"
															options={banks}
															// onChange={(e: any) => handleFilterTipoOps(e)}
														/>
													</div>

													{tipoConta === 'B' && (
														<>
															{/* AGÊNCIA DO BANCO */}
															<div className="input">
																<p>Agência do banco <span>obrigatório</span></p>

																<Input
																	name="banco_agencia"
																	type="text"
																	placeholder="Agência banco"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>

															{/* DÍGITO AGENCIA DO BANCO */}
															<div className="input">
																<p>Dígito da agência <span>obrigatório</span></p>

																<Input
																	name="banco_agencia_dig"
																	type="text"
																	placeholder="Dígito da agência"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>

															{/* NÚMERO DA CONTA */}
															<div className="input">
																<p>Número do Conta <span>obrigatório</span>
																</p>

																<Input
																	name="banco_conta_nro"
																	type="text"
																	placeholder="Número do Conta"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>

															{/* DIGITO DA CONTA */}
															<div className="input">
																<p>Dígito da conta <span>obrigatório</span></p>

																<Input
																	name="banco_conta_dig"
																	type="text"
																	placeholder="Dígito da conta"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>
														</>
													)}

													{tipoConta === 'CR' && (
														<>
															{/* CONTA DÉBITO DO CARTÃO NÚMERO */}
															<div className="input">
																<p>Conta débito cartão</p>

																<Input
																	name="cartao_conta_deb_nro"
																	type="text"
																	placeholder="Conta débito cartão"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>

															{/* DIGITO DA CONTA DE DÉBITO */}
															<div className="input">
																<p>Dígito da conta de débito</p>

																<Input
																	name="cartao_conta_deb_dig"
																	type="number"
																	placeholder="Dígito da conta de débito"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>

															{/* NÚMERO DA CARTÃO */}
															<div className="input">
																<p>Número do Cartão <span>obrigatório</span>
																</p>

																<Input
																	name="cartao_nro"
																	type="text"
																	placeholder="Número do cartão"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>
														</>
													)}

													{/* LIMITE DE CRÉDITO */}
													<div className="input">
														<p>Limite crédito  {tipoConta === 'CR' && <span>obrigatório</span>}</p>

														<Input
															name="limite_credito"
															type="text"
															placeholder="Limite crédito"
															containerStyle={{ padding: '5px 10px' }}
															onChange={handleMoeda}
														/>
													</div>

													{tipoConta === 'CR' && (
														<>
															{/* NOME DO CARTÃO */}
															<div className="input">
																<p>Nome do cartão <span>obrigatório</span></p>

																<Input
																	name="cartao_nome"
																	type="text"
																	placeholder="Nome do cartão"
																	containerStyle={{ padding: '5px 10px' }}
																/>
															</div>

															{/* VALIDADE DO CARTÃO */}
															<Flex direction="column" marginTop={2}>
																<Text fontSize={16} fontWeight={500}>Validade do cartão</Text>

																<Flex gap={4} padding={2} paddingTop={0} borderWidth={1} borderColor="gray.200" borderRadius={10}>
																	<Flex w="full">
																		{/* CÓDIGO DO BANCO */}
																		<div className="input">
																			<p>Mês <span>obrigatório</span></p>

																			<InputSelect
																				name="cartao_mes_validade"
																				placeholder="Mês"
																				options={months}
																				defaultValue={conta.cartao_mes_validade ? conta.cartao_mes_validade : ''}
																			// onChange={(e: any) => handleFilterTipoOps(e)}
																			/>
																		</div>
																	</Flex>

																	<Flex w="full">
																		{/* CÓDIGO DO BANCO */}
																		<div className="input">
																			<p>Ano <span>obrigatório</span></p>

																			<InputSelect
																				name="cartao_ano_validade"
																				placeholder="Ano"
																				options={years}
																				defaultValue={conta.cartao_ano_validade ? conta.cartao_ano_validade : ''}
																			// onChange={(e: any) => handleFilterTipoOps(e)}
																			/>
																		</div>
																	</Flex>
																</Flex>
															</Flex>


															<Flex gap={4}>
																{/* DIA DE VENCIMENTO DO CARTÃO */}
																<Flex w="50%">
																	<div className="input">
																		<p>Dia de vencimento <span>obrigatório</span></p>

																		<InputSelect
																			name="cartao_dia_vencimento"
																			placeholder="Dia vencimento"
																			options={days}
																			defaultValue={conta.cartao_dia_vencimento ? conta.cartao_dia_vencimento : ''}
																		// onChange={(e: any) => handleFilterTipoOps(e)}
																		/>
																	</div>
																</Flex>

																{/* DIA MELHOR COMPRA DO CARTÃO */}
																<Flex w="50%">
																	<div className="input">
																		<p>Melhor dia de compra <span>obrigatório</span></p>

																		<InputSelect
																			name="cartao_melhor_dia_compra"
																			placeholder="Melhor dia de compra"
																			options={days}
																			defaultValue={conta.cartao_melhor_dia_compra ? conta.cartao_melhor_dia_compra : ''}
																		// onChange={(e: any) => handleFilterTipoOps(e)}
																		/>
																	</div>
																</Flex>
															</Flex>															
														</>
													)}
												</>
											)}
										</div>

										<Buttons>
											<button
												type="button"
												className="button-cancel"
												// onClick={handleCancel}
												onClick={onOpen}
											>
												Cancelar
											</button>

											<button type="submit" className="button-save">
												Próximo
												{/* tipoConta === 'CR' || tipoConta === 'C' ?
													'Salvar' : 'Próximo'
												*/}
											</button>
										</Buttons>
									</FormView>
								</TabConta>

								{(tipoConta === 'B') && (
									<TabBoleto className="tab-panel">
										<div className="tab-content">
											<Header>
												<h1>Boleto</h1>
												<h2>Adicione aqui os dados do boleto bancário.</h2>
											</Header>

											<FormView ref={formRefBoleto} onSubmit={handleSubmitBoleto} initialData={conta.boleto}>
												<div className="form-left">
													{/* CNPJ - banco_documento */}
													<div className="input">
														<p>CNPJ <span>obrigatório</span></p>

														<Input
															name="documento"
															type="text"
															placeholder="CNPJ"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* NOME DO CEDENTE */}
													<div className="input">
														<p>Nome do cedente <span>obrigatório</span></p>

														<Input
															name="nome_boleto"
															type="text"
															placeholder="Nome do cedente"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* CÓDIGO CEDENTE */}
													<div className="input">
														<p>Código do cedente <span>obrigatório</span></p>

														<Input
															name="cedente"
															type="text"
															placeholder="Código do cedente"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* CÓDIGO CARTEIRA */}
													<div className="input">
														<p>Código da carteira <span>obrigatório</span></p>

														<Input
															name="carteira"
															type="text"
															placeholder="Código da carteira"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* CÓDIGO DA VARIAÇÃO */}
													<div className="input">
														<p>Código da variação <span>obrigatório</span></p>

														<Input
															name="variacao"
															type="text"
															placeholder="Código da variação"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* CÓDIGO DA TRANSFERENCIA DE ARQUIVO CNAB 240*/}
													<div className="input">
														<p>Código da transferência CNAB 240 <span>obrigatório</span></p>

														<Input
															name="codtrans240"
															type="text"
															placeholder="Código CNAB 240"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* CÓDIGO DA TRANSFERENCIA DE ARQUIVO CNAB 400 */}
													<div className="input">
														<p>Código da transferência CNAB 400 <span>obrigatório</span></p>

														<Input
															name="codtrans400"
															type="text"
															placeholder="Código CNAB 400"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* TIPO ARQUIVO */}
													<div className="input">
														<p>Tipo de arquivo <span>obrigatório</span></p>

														<InputSelect
															name="tip_arq"
															placeholder="Tipo de arquivo"
															options={selectTipoArquivo}
															defaultValue={conta.conta_tipo ? conta.id_caixa : ''}
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* TIPO DISTRIBUIÇÃO */}
													<div className="input">
														<p>Tipo de distribuição <span>obrigatório</span></p>

														<InputSelect
															name="tip_dist"
															placeholder="Tipo de distribuição"
															options={selectTipoDistribuicao}
															defaultValue={conta.conta_tipo ? conta.id_caixa : ''}
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* TIPO CARTEIRA */}
													<div className="input">
														<p>Tipo de carteira <span>obrigatório</span></p>

														<InputSelect
															name="tip_carteira"
															placeholder="Tipo de carteira"
															options={selectTipoCarteira}
															defaultValue={conta.conta_tipo ? conta.id_caixa : ''}
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													<SelectedYesNo>
														<h1>Aceite</h1>

														<div className="radio-group">
															<div className="radio">
																<div
																	className="radio-label"
																	onClick={() => setRadioAceite('N')}
																>
																	<input
																		type="radio"
																		value="N"
																		checked={radioAceite === 'N'}
																		onChange={() => setRadioAceite('N')}
																	/>
																	<label>Não</label>
																</div>
															</div>

															<div className="radio">
																<div
																	className="radio-label"
																	onClick={() => setRadioAceite('S')}
																>
																	<input
																		type="radio"
																		value="S"
																		checked={radioAceite === 'S'}
																		onChange={() => setRadioAceite('S')}
																	/>
																	<label>Sim</label>
																</div>
															</div>
														</div>
													</SelectedYesNo>

													{/* ESPÉCIE */}
													<div className="input">
														<p>Espécie <span>obrigatório</span></p>

														<InputSelect
															name="especie"
															placeholder="Espécie"
															options={selectTipoEspecie}
															defaultValue={conta.conta_tipo ? conta.id_caixa : ''}
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* RESPONSÁVEL */}
													<div className="input">
														<p>Responsável <span>obrigatório</span></p>

														<Input
															name="rep_emissao"
															type="text"
															placeholder="Responsável"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>
												</div>

												<Buttons>
													<button
														type="button"
														className="button-cancel"
														// onClick={handleCancel}
														onClick={onOpen}
													>
														Cancelar
													</button>

													<button
														type="submit"
														className="button-save"
													// disabled={}
													// onClick={handleSubmitCadastro}
													>
														Proximo
													</button>
												</Buttons>
											</FormView>
										</div>
									</TabBoleto>
								)}

								{(tipoConta === 'B') && (
									<TabPix className="tab-panel">
										<div className="tab-content">
											<Header>
												<h1>Pix</h1>
												<h2>Adicione aqui os dados do Pix.</h2>
											</Header>

											<FormView ref={formRefPix} onSubmit={handleSubmitPix} initialData={conta.pix}>
												<div className="form-left">
													{/* CLIENTE ID */}
													<div className="input">
														<p>Cliente ID <span>obrigatório</span></p>

														<Input
															name="client_id"
															type="text"
															placeholder="Cliente ID"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* CLIENTE SECRET */}
													<div className="input">
														<p>Cliente secret <span>obrigatório</span></p>

														<Input
															name="client_secret"
															type="text"
															placeholder="Cliente secret"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* SENHA DO PIX */}
													<div className="input">
														<p>Senha do Pix <span>obrigatório</span></p>

														<Input
															name="key_user"
															type="text"
															placeholder="Senha do Pix"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* PIX */}
													<div className="input">
														<p>Chave Pix <span>obrigatório</span></p>

														<Input
															name="chave_pix"
															type="text"
															placeholder="Chave Pix"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* SSL LIB */}
													<div className="input">
														<p>SSL LIB <span>obrigatório</span></p>

														<Input
															name="ssl_lib"
															type="number"
															placeholder="SSL LIB"
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>
												</div>

												<Buttons>
													<button
														type="button"
														className="button-cancel"
														// onClick={handleCancel}
														onClick={onOpen}
													>
														Cancelar
													</button>

													<button type="submit" className="button-save">
														Próximo
													</button>
												</Buttons>
											</FormView>
										</div>
									</TabPix>
								)}

								<TabUsers>
									<div className="tab-content">
										<Header>
											<h1>Usuários</h1>
											<h2>Adicione aqui os usuários que vão ter acesso a essa conta.</h2>
										</Header>

										
										<Table variant="simple" className="table">
											<Thead className="head">
												<Tr>
													<Th>Usuário</Th>
													<Th>Permissões</Th>
												</Tr>
											</Thead>

											<Tbody className="body">
												{usuarios.map((usuario) => (
													<Tr
														key={usuario.id_cliente}
														cursor="pointer"
														onClick={() => handleAddUser(usuario)}
														borderTopLeftRadius={10}
														borderBottomLeftRadius={10}
														backgroundColor={`${createConta.users?.find((ele: any) => ele === usuario.id_cliente) ? 'blue.500' : 'transparent'}`}
														color={`${createConta.users?.find((ele: any) => ele === usuario.id_cliente) ? 'white' : 'gray.700'}`}
														fontWeight={500}
														fontSize={16}
														rounded={8}
													>
														<Td>{usuario.nome}</Td>
														<Td>{usuario.role}</Td>
													</Tr>
												))}
											</Tbody>
										</Table>

										<Buttons>
											<button
												type="button"
												className="button-cancel"
												// onClick={handleCancel}
												onClick={onOpen}
											>
												Cancelar
											</button>

											<button type="submit" className="button-save" onClick={() => handleSubmitCadastro(createConta)}>
												Salvar
											</button>
										</Buttons>
									</div>
								</TabUsers>
							</TabPanels>
						</Tabs>
					</TabsView>
				</Content>
			</Container>

			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onCloseAlert}
				isCentered
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize='lg' fontWeight='bold'>
							Você não salvou suas alterações!
						</AlertDialogHeader>

						<AlertDialogBody>
							<Text fontFamily="heading">Deseja sair sem salvar?</Text>
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onCloseAlert}>
								Cancelar
							</Button>

							<Button
								colorScheme='red'
								ml={3}
								onClick={handleCancelar}
							>
								Sair
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
  );
};

export default ModalConta;
